import {
  auth,
  realtimedb,
  realtimedatabase,
  db,
  firestore,
} from "@/scripts/firebase";
import { collectionName } from "@/services/collection-name";
import { UserStatusState } from "@/services/user-status-state";
import { UserStatusDocument } from "@/services/datatypes";

export const userPresence = () => {
  // https://firebase.google.com/docs/firestore/solutions/presence?hl=ja
  const currentUser = auth.currentUser;
  if (!currentUser) {
    return;
  }
  const uid = currentUser.uid;

  const userStatusDatabaseRef = realtimedb.ref(
    `${collectionName.userstatus}/${uid}`
  );

  const isOfflineForDatabase: UserStatusDocument = {
    state: UserStatusState.Offline,
    timeLastChanged: realtimedatabase.ServerValue.TIMESTAMP,
  };

  const isOnlineForDatabase: UserStatusDocument = {
    state: UserStatusState.Online,
    timeLastChanged: realtimedatabase.ServerValue.TIMESTAMP,
  };

  // Create a reference to the special '.info/connected' path in
  // Realtime Database. This path returns `true` when connected
  // and `false` when disconnected.
  realtimedb.ref(".info/connected").on("value", function(snapshot) {
    // If we're not currently connected, don't do anything.
    if (snapshot.val() == false) {
      return;
    }

    // If we are currently connected, then use the 'onDisconnect()'
    // method to add a set which will only trigger once this
    // client has disconnected by closing the app,
    // losing internet, or any other means.
    userStatusDatabaseRef
      .onDisconnect()
      .set(isOfflineForDatabase)
      .then(function() {
        // The promise returned from .onDisconnect().set() will
        // resolve as soon as the server acknowledges the onDisconnect()
        // request, NOT once we've actually disconnected:
        // https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect

        // We can now safely set ourselves as 'online' knowing that the
        // server will mark us as offline once we lose connection.
        userStatusDatabaseRef.set(isOnlineForDatabase);
      });
  });
};

export const addUser = async (uid: string) => {
  db.collection(collectionName.users)
    .doc(uid)
    .set({
      uid: uid,
      timeLastAccessed: firestore.FieldValue.serverTimestamp(),
      timeUpdated: firestore.FieldValue.serverTimestamp(),
    });
  return "";
};

export const goOffline = async (uid: string) => {
  const userStatusDatabaseRef = realtimedb.ref(
    `${collectionName.userstatus}/${uid}`
  );

  const isOfflineForDatabase: UserStatusDocument = {
    state: UserStatusState.Offline,
    timeLastChanged: realtimedatabase.ServerValue.TIMESTAMP,
  };

  await userStatusDatabaseRef.set(isOfflineForDatabase);
};
